import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
const _excluded = ["boardId"],
  _excluded2 = ["boardId", "username"],
  _excluded3 = ["profileId", "id"],
  _excluded4 = ["id"];
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _Set from "@babel/runtime-corejs3/core-js/set";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import _reduceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/reduce";
import _parseInt from "@babel/runtime-corejs3/core-js/parse-int";
import _mapInstanceProperty from "@babel/runtime-corejs3/core-js/instance/map";
import _indexOfInstanceProperty from "@babel/runtime-corejs3/core-js/instance/index-of";
import _spliceInstanceProperty from "@babel/runtime-corejs3/core-js/instance/splice";
import _findInstanceProperty from "@babel/runtime-corejs3/core-js/instance/find";
import Vue from "vue";
import defaultState from "./client-profile-default-state";
import { updateField } from "@joandvgv/vuex-map-fields";
import { v4 as uuidv4 } from "uuid";
import { cloneDeep, isEmpty, mergeWith, omit } from "lodash";
import { clientProfileValueToNumber, sanitizeInputs } from "@Shared/@Utils/utils";
const appendMissingIds = (currentIds, nextIds) => {
  const existingIds = new _Set(currentIds);
  const missingIds = _filterInstanceProperty(nextIds).call(nextIds, id => !existingIds.has(id));
  return missingIds.length ? [...currentIds, ...missingIds] : currentIds;
};
export const SET_BOARDS = "SET_BOARDS";
export const SET_BOARD = "SET_BOARD";
export const SET_BOARD_COLLABORATORS = "SET_BOARD_COLLABORATORS";
export const SET_BOARD_CLIENTS = "SET_BOARD_CLIENTS";
export const SET_BOARD_STATUSES = "SET_BOARD_STATUSES";
export const SET_BOARD_CLIENT = "SET_BOARD_CLIENT";
export const SET_BOARD_STATUS_ORDER = "SET_BOARD_STATUS_ORDER";
export const SET_DEFAULT_BOARD_ID = "SET_DEFAULT_BOARD_ID";
export const INCREMENT_BOARD_CLIENTS = "INCREMENT_BOARD_CLIENTS";
export const DECREMENT_BOARD_CLIENTS = "DECREMENT_BOARD_CLIENTS";
export const ADD_BOARD_STATUS = "ADD_BOARD_STATUS";
export const SET_BOARD_STATUS = "SET_BOARD_STATUS";
export const REMOVE_BOARD_STATUS = "REMOVE_BOARD_STATUS";
export const SET_BOARD_ORDER = "SET_BOARD_ORDER";
export const MOVE_PROFILES_TO_COLUMN = "MOVE_PROFILES_TO_COLUMN";
export const REMOVE_CLIENT_BOARD = "REMOVE_CLIENT_BOARD";
export const SET_TRACK_EMAILS = "SET_TRACK_EMAILS";
export const SET_COLLABORATOR_DETAILS = "SET_COLLABORATOR_DETAILS";
export const SET_CLIENT_PROFILE_CARD_COLOR = "SET_CLIENT_PROFILE_CARD_COLOR";
export const REMOVE_CLIENT_PROFILE = "REMOVE_CLIENT_PROFILE";
export const ADD_BOARD_CLIENT_REMINDERS = "ADD_BOARD_CLIENT_REMINDERS";
export const SET_BOARD_CLIENT_REMINDERS = "SET_BOARD_CLIENT_REMINDERS";
export const SET_BOARD_COLLABORATOR = "SET_BOARD_COLLABORATOR";
export const REMOVE_BOARD_COLLABORATOR = "REMOVE_BOARD_COLLABORATOR";
export const CHANGE_BOARD_TO_DEFAULT = "CHANGE_BOARD_TO_DEFAULT";
export const EDIT_CLIENT_PROFILE_REMINDER = "EDIT_CLIENT_PROFILE_REMINDER";
export const REMOVE_COMPLETE_CLIENT_PROFILE_REMINDERS = "REMOVE_COMPLETE_CLIENT_PROFILE_REMINDERS";
export const SET_ACTIVITY_SORT = "SET_ACTIVITY_SORT";
export const SET_ACTIVE_SEARCH_STRING = "SET_ACTIVE_SEARCH_STRING";
export const SET_CUSTOM_FIELDS_DEFINITIONS = "SET_CUSTOM_FIELDS_DEFINITIONS";
export const SET_CUSTOM_FIELD_TRANSLATION_MAP = "SET_CUSTOM_FIELD_TRANSLATION_MAP";
export const ADD_CUSTOM_FIELD_DEFINITION = "ADD_CUSTOM_FIELD_DEFINITION";
export const SET_CUSTOM_FIELD_DEFINITION = "SET_CUSTOM_FIELD_DEFINITION";
export const SET_CUSTOM_FIELD_ORDER = "SET_CUSTOM_FIELD_ORDER";
export const REMOVE_CUSTOM_FIELD_DEFINITION = "REMOVE_CUSTOM_FIELD_DEFINITION";
export const SET_BOARD_PROFILE = "SET_BOARD_PROFILE";
export const SET_BOARD_FILTER = "SET_BOARD_FILTER";
export const SET_PROFILE_NOTIFIED_REFERRERS = "SET_PROFILE_NOTIFIED_REFERRERS";
export const SET_EMAIL_TACKING = "SET_EMAIL_TACKING";
export const UPDATE_PROFILE_COLLABORATORS = "UPDATE_PROFILE_COLLABORATORS";
export const UPDATE_PROFILE_COLLABORATOR_DETAILS = "UPDATE_PROFILE_COLLABORATOR_DETAILS";
export const SET_PROFILE_ACTIVE = "SET_PROFILE_ACTIVE";
export const UPDATE_PROFILE_COAPPLICANTS = "UPDATE_PROFILE_COAPPLICANTS";
export const SET_LINKED_USERNAME = "SET_LINKED_USERNAME";
export const ADD_NOTIFIED_REFERRER = "ADD_NOTIFIED_REFERRER";
export const REMOVE_NOTIFIED_REFERRER = "REMOVE_NOTIFIED_REFERRER";
export const SET_PROFILE_TIMELINE = "SET_PROFILE_TIMELINE";
export const SET_TIMELINE_REMAINING = "SET_TIMELINE_REMAINING";
export const REMOVE_TIMELINE_ITEM = "REMOVE_TIMELINE_ITEM";
export const SET_TIMELINE_ITEM_DETAILS = "SET_TIMELINE_ITEM_DETAILS";
export const SET_CUSTOM_FIELDS_DATA = "SET_CUSTOM_FIELDS_DATA";
export const SET_INACTIVE_PROFILES = "SET_INACTIVE_PROFILES";
export const SET_INACTIVE_FILTERS = "SET_INACTIVE_FILTERS";
export const ADD_TIMELINE_ITEM = "ADD_TIMELINE_ITEM";
export const SET_CHANGELOG = "SET_CHANGELOG";
export const SET_EMAIL_TEMPLATES = "SET_EMAIL_TEMPLATES";
export const SET_CHECKLIST_TEMPLATES = "SET_CHECKLIST_TEMPLATES";
export const ADD_TEMPLATE_ITEM = "ADD_TEMPLATE_ITEM";
export const UPDATE_TEMPLATE_ITEM = "UPDATE_TEMPLATE_ITEM";
export const REMOVE_TEMPLATE_ITEM = "REMOVE_TEMPLATE_ITEM";
export const ADD_CHECKLIST_TEMPLATE_ITEM = "ADD_CHECKLIST_TEMPLATE_ITEM";
export const REMOVE_CHECKLIST_TEMPLATE_ITEM = "REMOVE_CHECKLIST_TEMPLATE_ITEM";
export const ADD_CO_APPLICANT_ITEM = "ADD_CO_APPLICANT_ITEM";
export const REMOVE_CO_APPLICANT_ITEM = "REMOVE_CO_APPLICANT_ITEM";
export const UPDATE_CO_APPLICANT_ITEM = "UPDATE_CO_APPLICANT_ITEM";
export const SET_PROFILE_COLLABORATORS = "SET_PROFILE_COLLABORATORS";
export const SET_REFERRER = "SET_REFERRER";
export const SET_STATUS_LABELS = "SET_STATUS_LABELS";
export const UPDATE_STATUS_LABEL = "UPDATE_STATUS_LABEL";
export const UPDATE_UPDATED_AT = "UPDATE_UPDATED_AT";
export const UPDATE_PROFILE_OWNER = "UPDATE_PROFILE_OWNER";
export const SET_CLIENT_PROFILE = "SET_CLIENT_PROFILE";
export const TOGGLE_STARRED_APPLICATION = "TOGGLE_STARRED_APPLICATION";
export const SET_BOARD_CHANGELOG = "SET_BOARD_CHANGELOG";
export const RESET_BOARD_CHANGELOG = "RESET_BOARD_CHANGELOG";
export const SET_CLIENT_LISTS = "SET_CLIENT_LISTS";
export const SET_CLIENT_CAMPAIGNS = "SET_CLIENT_CAMPAIGNS";
export const REMOVE_CLIENT_PROFILES = "REMOVE_CLIENT_PROFILES";
export const SET_PROFILE_MASTER_SUBSCRIBE = "SET_PROFILE_MASTER_SUBSCRIBE";
export const SET_CLIENT_PROFILES_WITH_CHANGES = "SET_CLIENT_PROFILES_WITH_CHANGES";
export const SET_CHANGELOG_LAST_CHANGES = "SET_CHANGELOG_LAST_CHANGES";
export const REMOVE_CHANGELOG_LAST_CHANGES = "REMOVE_CHANGELOG_LAST_CHANGES";
export const SET_PROFILE_MASTER_SUBSCRIBE_AUTHOR = "SET_PROFILE_MASTER_SUBSCRIBE_AUTHOR";
export const SET_EMAIL_BODY = "SET_EMAIL_BODY";
export const SET_PROFILE_STRUCTURE = "SET_PROFILE_STRUCTURE";
export const REMOVE_PROFILE_FROM_ORDER = "REMOVE_PROFILE_FROM_ORDER";
export const REMOVE_BOARD_CLIENT_REMINDER = "REMOVE_BOARD_CLIENT_REMINDER";
export const SET_INACTIVE_PROFILE_STRUCTURE = "SET_INACTIVE_PROFILE_STRUCTURE";
export const SET_USER_DETAILS = "SET_USER_DETAILS";
export const ADD_BOARD = "ADD_BOARD";
export const SET_PROFILE_PARTICIPANTS = "SET_PROFILE_PARTICIPANTS";
const mutations = {
  updateField,
  [SET_PROFILE_STRUCTURE]: (state, clientProfileId) => {
    if (!state.clientProfiles.byId[clientProfileId]) {
      state.clientProfiles.allIds.push(clientProfileId);
      Vue.set(state.clientProfiles.byId, clientProfileId, cloneDeep(defaultState()));
    }
  },
  [SET_INACTIVE_PROFILE_STRUCTURE]: (state, clientProfileId) => {
    if (!state.inactiveTable.inactiveClientProfiles.byId[clientProfileId]) {
      state.inactiveTable.inactiveClientProfiles.allIds.push(clientProfileId);
      Vue.set(state.inactiveTable.inactiveClientProfiles.byId, clientProfileId, cloneDeep(defaultState()));
    }
  },
  [SET_BOARDS]: (state, payload) => {
    Vue.set(state, "boards", payload);
  },
  [SET_USER_DETAILS]: (state, agentUsername) => {
    Vue.set(state, "agentUsername", agentUsername);
  },
  [ADD_BOARD]: (state, newBoard) => {
    Vue.set(state.boards.byId, newBoard.id, newBoard);
    state.boards.allIds.push(newBoard.id);
  },
  [SET_BOARD]: (state, board) => {
    state.boards.byId[board.id] = _objectSpread(_objectSpread({}, state.boards.byId[board.id]), board);
  },
  [SET_BOARD_COLLABORATORS]: (state, _ref) => {
    let {
        boardId
      } = _ref,
      payload = _objectWithoutProperties(_ref, _excluded);
    state.collaborators = _objectSpread(_objectSpread({}, state.collaborators || {}), {}, {
      [boardId]: payload
    });
  },
  [SET_BOARD_COLLABORATOR]: (state, {
    boardId,
    collaborator
  }) => {
    var _context;
    state.collaborators[boardId].byId = _objectSpread(_objectSpread({}, state.collaborators[boardId].byId), {}, {
      [collaborator.username]: collaborator
    });
    if (!_includesInstanceProperty(_context = state.collaborators[boardId].allIds).call(_context, collaborator.username)) state.collaborators[boardId].allIds = [...state.collaborators[boardId].allIds, collaborator.username];
  },
  [REMOVE_BOARD_COLLABORATOR]: (state, {
    boardId,
    collaboratorUsername
  }) => {
    var _context2;
    const collaborators = state.collaborators[boardId].byId;
    delete collaborators[collaboratorUsername];
    state.collaborators[boardId].byId = _objectSpread({}, collaborators);
    state.collaborators[boardId].allIds = _filterInstanceProperty(_context2 = state.collaborators[boardId].allIds).call(_context2, username => username !== collaboratorUsername);
  },
  [CHANGE_BOARD_TO_DEFAULT]: state => {
    state.selectedBoardId = state.defaultBoardId;
  },
  [SET_BOARD_CLIENTS]: (state, {
    boardId,
    clientProfiles,
    replace = false
  }) => {
    var _context3;
    if (!state.boards.byId[boardId].boardProfiles) {
      Vue.set(state.boards.byId[boardId], "boardProfiles", []);
    }
    if (replace) {
      state.boards.byId[boardId].boardProfiles = [];
    }
    state.boards.byId[boardId].boardProfiles = appendMissingIds(state.boards.byId[boardId].boardProfiles, clientProfiles.allIds);
    state.clientProfiles.allIds = appendMissingIds(state.clientProfiles.allIds, clientProfiles.allIds);
    const profilesById = _reduceInstanceProperty(_context3 = clientProfiles.allIds).call(_context3, (profiles, id) => {
      profiles[id] = _objectSpread(_objectSpread(_objectSpread({}, state.clientProfiles.byId[id] ? {} : cloneDeep(defaultState())), state.clientProfiles.byId[id]), clientProfiles.byId[id]);
      return profiles;
    }, {});
    Vue.set(state.clientProfiles, "byId", _objectSpread(_objectSpread({}, state.clientProfiles.byId), profilesById));
  },
  [SET_BOARD_STATUSES]: (state, {
    boardId,
    statistics,
    translationMap,
    replace = false
  }) => {
    if (!state.boardsStatuses[boardId] || replace) {
      Vue.set(state.boardsStatuses, boardId, {
        byId: {},
        allIds: []
      });
    }
    state.boardsStatuses[boardId].allIds = appendMissingIds(state.boardsStatuses[boardId].allIds, statistics.allIds);
    statistics.allIds.forEach(statusId => {
      const status = statistics.byId[statusId];
      Vue.set(state.boardsStatuses[boardId].byId, statusId, _objectSpread(_objectSpread(_objectSpread({}, state.boardsStatuses[boardId].byId[statusId]), status), {}, {
        order: [...(status.order || [])]
      }));
    });
    Vue.set(state.boardsStatusesTranslationMap, boardId, translationMap);
  },
  [SET_BOARD_CLIENT]: (state, {
    clientProfile
  }) => {
    var _context4;
    state.clientProfiles.byId = _objectSpread(_objectSpread({}, state.clientProfiles.byId), {}, {
      [clientProfile.id]: clientProfile
    });
    if (!_includesInstanceProperty(_context4 = state.clientProfiles.allIds).call(_context4, clientProfile.id)) {
      state.clientProfiles.allIds.push(clientProfile.id);
    }
  },
  [SET_BOARD_STATUS_ORDER]: (state, {
    boardId,
    order,
    statusLabelId
  }) => {
    const clientProfiles = state.clientProfiles.byId;
    const newValue = _reduceInstanceProperty(order).call(order, (acc, clientProfileId) => {
      const clientProfileValue = clientProfileValueToNumber(clientProfiles[clientProfileId].value);
      return clientProfileValue + acc;
    }, 0);
    state.boardsStatuses[boardId].byId = _objectSpread(_objectSpread({}, state.boardsStatuses[boardId].byId), {}, {
      [statusLabelId]: _objectSpread(_objectSpread({}, state.boardsStatuses[boardId].byId[statusLabelId]), {}, {
        order,
        count: order.length,
        value: newValue
      })
    });
  },
  [SET_DEFAULT_BOARD_ID]: (state, {
    defaultBoardId
  }) => {
    if (state.defaultBoardId) {
      state.boards.byId[state.defaultBoardId].default = false;
    }
    state.defaultBoardId = defaultBoardId;
    state.boards.byId[defaultBoardId].default = true;
  },
  [INCREMENT_BOARD_CLIENTS]: (state, {
    boardId,
    factor = 1
  }) => {
    const {
      numberOfClients
    } = state.boards.byId[boardId];
    state.boards.byId[boardId].numberOfClients = _parseInt(numberOfClients) + factor + "";
  },
  [DECREMENT_BOARD_CLIENTS]: (state, {
    boardId,
    factor = 1
  }) => {
    const {
      numberOfClients
    } = state.boards.byId[boardId];
    state.boards.byId[boardId].numberOfClients = _parseInt(numberOfClients) - factor + "";
  },
  [ADD_BOARD_STATUS]: (state, {
    boardId,
    status
  }) => {
    state.boardsStatuses[boardId].byId = _objectSpread(_objectSpread({}, state.boardsStatuses[boardId].byId), {}, {
      [status.id]: status
    });
    state.boardsStatuses[boardId].allIds.push(status.id);
    state.boards.byId[boardId].order.push(status.id);
  },
  [SET_BOARD_STATUS]: (state, {
    boardId,
    status
  }) => {
    state.boardsStatuses[boardId].byId[status.id] = _objectSpread(_objectSpread({}, state.boardsStatuses[boardId].byId[status.id]), status);
  },
  [REMOVE_BOARD_STATUS]: (state, {
    boardId,
    statusLabelId
  }) => {
    var _context5, _context6;
    delete state.boardsStatuses[boardId].byId[statusLabelId];
    state.boardsStatuses[boardId].allIds = _filterInstanceProperty(_context5 = state.boardsStatuses[boardId].allIds).call(_context5, bId => bId !== statusLabelId);
    state.boards.byId[boardId].order = _filterInstanceProperty(_context6 = state.boards.byId[boardId].order).call(_context6, bId => bId !== statusLabelId);
  },
  [SET_BOARD_ORDER]: (state, {
    boardId,
    order
  }) => {
    state.boards.byId[boardId] = _objectSpread(_objectSpread({}, state.boards.byId[boardId]), {}, {
      order
    });
  },
  [MOVE_PROFILES_TO_COLUMN]: (state, {
    boardId,
    statusLabelId,
    profiles
  }) => {
    profiles.forEach(profileId => {
      state.clientProfiles.byId[profileId] = _objectSpread(_objectSpread({}, state.clientProfiles.byId[profileId]), {}, {
        statusLabelId
      });
    });
    const order = [...(state.boardsStatuses[boardId].byId[statusLabelId].order || []), ...profiles];
    const clientProfiles = state.clientProfiles.byId;
    const newValue = _reduceInstanceProperty(order).call(order, (acc, clientProfileId) => {
      const clientProfileValue = clientProfileValueToNumber(clientProfiles[clientProfileId].value);
      return clientProfileValue + acc;
    }, 0);
    state.boardsStatuses[boardId].byId = _objectSpread(_objectSpread({}, state.boardsStatuses[boardId].byId), {}, {
      [statusLabelId]: _objectSpread(_objectSpread({}, state.boardsStatuses[boardId].byId[statusLabelId]), {}, {
        order,
        count: order.length,
        value: newValue
      })
    });
  },
  [REMOVE_CLIENT_BOARD]: (state, {
    boardId
  }) => {
    var _context8;
    state.boards.byId[boardId].boardProfiles.forEach(id => {
      var _context7;
      Vue.delete(state.clientProfiles.byId, id);
      state.clientProfiles.allIds = _filterInstanceProperty(_context7 = state.clientProfiles.allIds).call(_context7, i => i !== id);
    });
    state.boards.allIds = _filterInstanceProperty(_context8 = state.boards.allIds).call(_context8, b => b !== boardId);
    Vue.delete(state.boards.byId, boardId);
    Vue.delete(state.boardsStatuses, boardId);
    state.selectedBoardId = state.defaultBoardId;
  },
  [SET_TRACK_EMAILS]: (state, {
    boardId,
    trackEmails
  }) => {
    state.boards.byId[boardId] = _objectSpread(_objectSpread({}, state.boards.byId[boardId]), {}, {
      trackEmails
    });
  },
  [SET_COLLABORATOR_DETAILS]: (state, _ref2) => {
    let {
        boardId,
        username
      } = _ref2,
      details = _objectWithoutProperties(_ref2, _excluded2);
    state.collaborators[boardId].byId[username] = _objectSpread(_objectSpread({}, state.collaborators[boardId].byId[username]), details);
  },
  [SET_CLIENT_PROFILE_CARD_COLOR]: (state, {
    clientProfileId,
    cardColour
  }) => {
    state.clientProfiles.byId[clientProfileId] = _objectSpread(_objectSpread({}, state.clientProfiles.byId[clientProfileId]), {}, {
      cardColour
    });
  },
  [REMOVE_CLIENT_PROFILE]: (state, {
    boardId,
    clientProfileId
  }) => {
    var _context0, _context1;
    const statusLabelId = state.clientProfiles.byId[clientProfileId].statusLabelId;
    if (state.boards.byId[boardId].boardProfiles) {
      var _context9;
      state.boards.byId[boardId].boardProfiles = _filterInstanceProperty(_context9 = state.boards.byId[boardId].boardProfiles).call(_context9, id => id !== clientProfileId);
    }
    Vue.delete(state.clientProfiles.byId, clientProfileId);
    state.clientProfiles.allIds = _filterInstanceProperty(_context0 = state.clientProfiles.allIds).call(_context0, i => i !== clientProfileId);
    const order = _filterInstanceProperty(_context1 = state.boardsStatuses[boardId].byId[statusLabelId].order || []).call(_context1, o => o !== clientProfileId);
    const clientProfiles = state.clientProfiles.byId;
    const newValue = _reduceInstanceProperty(order).call(order, (acc, clientProfileId) => {
      const clientProfileValue = clientProfileValueToNumber(clientProfiles[clientProfileId].value);
      return clientProfileValue + acc;
    }, 0);
    state.boardsStatuses[boardId].byId = _objectSpread(_objectSpread({}, state.boardsStatuses[boardId].byId), {}, {
      [statusLabelId]: _objectSpread(_objectSpread({}, state.boardsStatuses[boardId].byId[statusLabelId]), {}, {
        order,
        count: order.length,
        value: newValue
      })
    });
  },
  [REMOVE_CLIENT_PROFILES]: (state, {
    boardId,
    statusLabelId
  }) => {
    var _state$boardsStatuses, _context10;
    const clientProfileIds = ((_state$boardsStatuses = state.boardsStatuses[boardId].byId[statusLabelId]) == null ? void 0 : _state$boardsStatuses.order) || [];
    state.boards.byId[boardId].boardProfiles = _filterInstanceProperty(_context10 = state.boards.byId[boardId].boardProfiles).call(_context10, id => !_includesInstanceProperty(clientProfileIds).call(clientProfileIds, id));
    state.boardsStatuses[boardId].byId = _objectSpread(_objectSpread({}, state.boardsStatuses[boardId].byId), {}, {
      [statusLabelId]: _objectSpread(_objectSpread({}, state.boardsStatuses[boardId].byId[statusLabelId]), {}, {
        order: [],
        count: 0,
        value: 0
      })
    });
  },
  [ADD_BOARD_CLIENT_REMINDERS]: (state, {
    clientProfileId,
    reminders
  }) => {
    const newReminders = [...(state.clientProfiles.byId[clientProfileId].reminders || []), ...reminders];
    state.clientProfiles.byId[clientProfileId] = _objectSpread(_objectSpread({}, state.clientProfiles.byId[clientProfileId]), {}, {
      reminders: newReminders,
      followUpCount: newReminders.length.toString()
    });
  },
  [REMOVE_BOARD_CLIENT_REMINDER]: (state, {
    clientProfileId,
    reminderId
  }) => {
    var _clientProfile$remind;
    const clientProfile = state.clientProfiles.byId[clientProfileId];
    const reminders = (_clientProfile$remind = clientProfile.reminders) == null ? void 0 : _filterInstanceProperty(_clientProfile$remind).call(_clientProfile$remind, ({
      id
    }) => id !== reminderId);
    Vue.set(state.clientProfiles.byId[clientProfileId], "reminders", reminders);
  },
  [SET_BOARD_CLIENT_REMINDERS]: (state, {
    clientProfileId,
    reminders
  }) => {
    state.clientProfiles.byId[clientProfileId] = _objectSpread(_objectSpread({}, state.clientProfiles.byId[clientProfileId]), {}, {
      reminders
    });
  },
  [EDIT_CLIENT_PROFILE_REMINDER]: (state, {
    clientProfileId,
    reminder
  }) => {
    var _state$clientProfiles, _state$clientProfiles2;
    const reminders = (_state$clientProfiles = state.clientProfiles.byId) == null ? void 0 : (_state$clientProfiles2 = _state$clientProfiles[clientProfileId].reminders) == null ? void 0 : _mapInstanceProperty(_state$clientProfiles2).call(_state$clientProfiles2, currentReminder => {
      if (currentReminder.id === reminder.id) return _objectSpread(_objectSpread({}, currentReminder), reminder);
      return currentReminder;
    });
    Vue.set(state.clientProfiles.byId[clientProfileId], "reminders", reminders);
  },
  [REMOVE_COMPLETE_CLIENT_PROFILE_REMINDERS]: (state, {
    clientProfileId
  }) => {
    var _state$clientProfiles3, _state$clientProfiles4;
    const reminders = (_state$clientProfiles3 = state.clientProfiles.byId) == null ? void 0 : (_state$clientProfiles4 = _state$clientProfiles3[clientProfileId].reminders) == null ? void 0 : _filterInstanceProperty(_state$clientProfiles4).call(_state$clientProfiles4, ({
      complete
    }) => !complete);
    state.clientProfiles.byId[clientProfileId] = _objectSpread(_objectSpread({}, state.clientProfiles.byId[clientProfileId]), {}, {
      reminders,
      followUpCount: (reminders == null ? void 0 : reminders.length.toString()) || "0"
    });
  },
  [SET_ACTIVITY_SORT]: (state, {
    boardId,
    sortBy,
    noActivityFirst,
    sortByOrder
  }) => {
    state.boards.byId[boardId] = _objectSpread(_objectSpread({}, state.boards.byId[boardId]), {}, {
      sortBy,
      noActivityFirst,
      sortByOrder
    });
  },
  [SET_ACTIVE_SEARCH_STRING]: (state, {
    clientProfileSearchString
  }) => {
    state.clientProfileSearchString = clientProfileSearchString;
  },
  [SET_CUSTOM_FIELDS_DEFINITIONS]: (state, {
    boardId,
    boardsCustomFieldsDefinitions
  }) => {
    Vue.set(state.boardsCustomFieldsDefinitions, boardId, boardsCustomFieldsDefinitions);
  },
  [ADD_CUSTOM_FIELD_DEFINITION]: (state, {
    boardId,
    customFieldDefinition
  }) => {
    Vue.set(state.boardsCustomFieldsDefinitions[boardId].byId, customFieldDefinition.id, customFieldDefinition);
    Vue.set(state.boardsCustomFieldsDefinitions[boardId], "allIds", [...state.boardsCustomFieldsDefinitions[boardId].allIds, customFieldDefinition.id]);
  },
  [SET_CUSTOM_FIELD_DEFINITION]: (state, {
    boardId,
    customFieldDefinition
  }) => {
    Vue.set(state.boardsCustomFieldsDefinitions[boardId].byId, customFieldDefinition.id, customFieldDefinition);
  },
  [SET_CUSTOM_FIELD_ORDER]: (state, {
    customFieldDefinitions,
    boardId
  }) => {
    const byId = state.boardsCustomFieldsDefinitions[boardId].byId;
    const updatedCustomFields = _reduceInstanceProperty(customFieldDefinitions).call(customFieldDefinitions, (acc, current) => {
      acc[current.id] = _objectSpread(_objectSpread({}, byId[current.id]), {}, {
        fieldOrder: current.fieldOrder
      });
      return acc;
    }, {});
    Vue.set(state.boardsCustomFieldsDefinitions[boardId], "byId", updatedCustomFields);
  },
  [REMOVE_CUSTOM_FIELD_DEFINITION]: (state, {
    boardId,
    customFieldDefinitionId
  }) => {
    var _context11;
    Vue.delete(state.boardsCustomFieldsDefinitions[boardId].byId, customFieldDefinitionId);
    state.boardsCustomFieldsDefinitions[boardId].allIds = _filterInstanceProperty(_context11 = state.boardsCustomFieldsDefinitions[boardId].allIds).call(_context11, id => id !== customFieldDefinitionId);
  },
  [SET_BOARD_PROFILE]: (state, {
    clientProfileId,
    details
  }) => {
    const detailsToUse = _objectSpread(_objectSpread({}, omit(details, "details")), details.details);
    state.clientProfiles.byId[clientProfileId] = _objectSpread(_objectSpread({}, state.clientProfiles.byId[clientProfileId]), detailsToUse);
  },
  [SET_CUSTOM_FIELD_TRANSLATION_MAP]: (state, {
    boardId,
    translationMap
  }) => {
    state.customFieldsTranslationMap[boardId] = translationMap;
  },
  [SET_BOARD_FILTER]: (state, {
    boardId,
    clientBoardFilter
  }) => {
    state.boards.byId[boardId] = _objectSpread(_objectSpread({}, state.boards.byId[boardId]), {}, {
      clientBoardFilter
    });
  },
  [SET_PROFILE_NOTIFIED_REFERRERS]: (state, {
    clientProfileId,
    notifiedReferrers
  }) => {
    Vue.set(state.clientProfiles.byId[clientProfileId], "notifiedReferrers", notifiedReferrers);
  },
  [SET_EMAIL_TACKING]: (state, {
    id,
    trackEmails
  }) => {
    Vue.set(state.clientProfiles.byId[id], "trackEmails", trackEmails);
  },
  [UPDATE_PROFILE_COLLABORATORS]: (state, {
    action,
    id,
    collaborator
  }) => {
    if (action === "add") {
      state.clientProfiles.byId[id].collaborators.byId = _objectSpread(_objectSpread({}, state.clientProfiles.byId[id].collaborators.byId), {}, {
        [collaborator.username]: collaborator
      });
      state.clientProfiles.byId[id].collaborators.allIds.push(collaborator.username);
    } else if (action === "remove") {
      var _context12;
      delete state.clientProfiles.byId[id].collaborators.byId[collaborator.username];
      state.clientProfiles.byId[id].collaborators.allIds = _filterInstanceProperty(_context12 = state.clientProfiles.byId[id].collaborators.allIds).call(_context12, username => username !== collaborator.username);
    }
  },
  [UPDATE_PROFILE_COLLABORATOR_DETAILS]: (state, {
    id,
    username,
    key,
    value
  }) => {
    state.clientProfiles.byId[id].collaborators.byId[username] = _objectSpread(_objectSpread({}, state.clientProfiles.byId[id].collaborators.byId[username]), {}, {
      [key]: value
    });
  },
  [SET_PROFILE_ACTIVE]: (state, {
    id,
    active
  }) => {
    if (state.inactiveTable.inactiveClientProfiles.byId[id]) {
      Vue.set(state.inactiveTable.inactiveClientProfiles.byId[id], "active", active);
    }
    if (state.clientProfiles.byId[id]) {
      Vue.set(state.clientProfiles.byId[id], "active", active);
    }
  },
  [SET_REFERRER]: (state, {
    profileId,
    referrerId
  }) => {
    Vue.set(state.clientProfiles.byId[profileId], "referrerId", referrerId);
  },
  [SET_STATUS_LABELS]: (state, {
    id,
    statusLabels
  }) => {
    Vue.set(state.clientProfiles.byId[id], "statusLabels", statusLabels);
  },
  [UPDATE_PROFILE_COAPPLICANTS]: (state, {
    id,
    coApplicants
  }) => {
    Vue.set(state.clientProfiles.byId[id], "coApplicants", coApplicants);
  },
  [SET_LINKED_USERNAME]: (state, {
    id,
    accountUsername
  }) => {
    Vue.set(state.clientProfiles.byId[id], "linkedAccountUsername", accountUsername);
  },
  [ADD_NOTIFIED_REFERRER]: (state, {
    id,
    referrer,
    subscriber
  }) => {
    const {
      notifiedReferrers
    } = state.clientProfiles.byId[id];
    const {
      subscriberId
    } = subscriber;
    notifiedReferrers.allIds.push(subscriberId);
    notifiedReferrers.byId[subscriberId] = referrer;
  },
  [REMOVE_NOTIFIED_REFERRER]: (state, {
    id,
    referrerId
  }) => {
    var _context13, _context14;
    const {
      notifiedReferrers
    } = state.clientProfiles.byId[id];
    const index = _indexOfInstanceProperty(_context13 = notifiedReferrers.allIds).call(_context13, referrerId);
    _spliceInstanceProperty(_context14 = notifiedReferrers.allIds).call(_context14, index, 1);
    delete notifiedReferrers.byId[referrerId];
  },
  [SET_PROFILE_TIMELINE]: (state, {
    id,
    timeline
  }) => {
    Vue.set(state.clientProfiles.byId[id], "timeline", timeline);
  },
  [SET_TIMELINE_REMAINING]: (state, {
    id,
    timelineActivityLeft
  }) => {
    Vue.set(state.clientProfiles.byId[id], "timelineActivityLeft", timelineActivityLeft);
  },
  [SET_TIMELINE_ITEM_DETAILS]: (state, _ref3) => {
    let {
        profileId,
        id
      } = _ref3,
      details = _objectWithoutProperties(_ref3, _excluded3);
    state.clientProfiles.byId[profileId].timeline.byId[id] = _objectSpread(_objectSpread({}, state.clientProfiles.byId[profileId].timeline.byId[id]), details);
  },
  [SET_CUSTOM_FIELDS_DATA]: async (state, {
    clientProfileId,
    customFields
  }) => {
    Vue.set(state.clientProfiles.byId[clientProfileId], "customFields", customFields);
  },
  [SET_INACTIVE_PROFILES]: (state, {
    inactiveClientProfiles,
    allIds,
    total,
    add
  }) => {
    if (add) {
      state.inactiveTable.inactiveClientProfiles.byId = _objectSpread(_objectSpread({}, state.inactiveTable.inactiveClientProfiles.byId), inactiveClientProfiles);
      state.inactiveTable.inactiveClientProfiles.allIds.push(...allIds);
    } else {
      state.inactiveTable.inactiveClientProfiles.byId = _objectSpread({}, inactiveClientProfiles);
      state.inactiveTable.inactiveClientProfiles.allIds = allIds;
    }
    state.inactiveTable.totalInactive = total;
  },
  [SET_INACTIVE_FILTERS]: (state, {
    orderBy,
    orderType,
    searchString,
    boardIds
  }) => {
    state.inactiveTable.inactiveTableFilters = mergeWith({}, state.inactiveTable.inactiveTableFilters, {
      orderBy,
      orderType,
      searchString,
      boardIds
    }, (current, replacement) => replacement != null ? replacement : current);
  },
  [ADD_TIMELINE_ITEM]: (state, {
    profileId,
    newItem
  }) => {
    var _state$clientProfiles5, _state$clientProfiles6, _state$clientProfiles7;
    if ((_state$clientProfiles5 = state.clientProfiles) != null && (_state$clientProfiles6 = _state$clientProfiles5.byId) != null && (_state$clientProfiles7 = _state$clientProfiles6[profileId]) != null && _state$clientProfiles7.timeline) {
      state.clientProfiles.byId[profileId].timeline.byId = _objectSpread(_objectSpread({}, state.clientProfiles.byId[profileId].timeline.byId), {}, {
        [newItem.id]: newItem
      });
      state.clientProfiles.byId[profileId].timeline.allIds.unshift(newItem.id);
    }
  },
  [SET_CHANGELOG]: (state, {
    changelog,
    clientProfileId
  }) => {
    Vue.set(state.clientProfiles.byId[clientProfileId], "changelog", changelog);
  },
  [REMOVE_TIMELINE_ITEM]: (state, {
    profileId,
    id
  }) => {
    var _context15;
    delete state.clientProfiles.byId[profileId].timeline.byId[id];
    state.clientProfiles.byId[profileId].timeline.byId = _objectSpread({}, state.clientProfiles.byId[profileId].timeline.byId);
    state.clientProfiles.byId[profileId].timeline.allIds = _filterInstanceProperty(_context15 = state.clientProfiles.byId[profileId].timeline.allIds).call(_context15, item => item !== id);
  },
  [SET_EMAIL_TEMPLATES]: (state, payload) => {
    state.emailTemplates = payload;
  },
  [ADD_TEMPLATE_ITEM]: (state, {
    id,
    emailData
  }) => {
    state.emailTemplates.byId = _objectSpread(_objectSpread({}, state.emailTemplates.byId), {}, {
      [id]: _objectSpread(_objectSpread({}, emailData), {}, {
        id
      })
    });
  },
  [UPDATE_TEMPLATE_ITEM]: (state, {
    id,
    emailData
  }) => {
    state.emailTemplates.byId[id] = _objectSpread(_objectSpread({}, state.emailTemplates.byId[id]), emailData);
    state.emailTemplates.allIds.push(id);
  },
  [REMOVE_TEMPLATE_ITEM]: (state, {
    id
  }) => {
    var _context16;
    Vue.delete(state.emailTemplates.byId, id);
    state.emailTemplates.allIds = _filterInstanceProperty(_context16 = state.emailTemplates.allIds).call(_context16, item => item !== id);
  },
  [SET_CHECKLIST_TEMPLATES]: (state, payload) => {
    state.checklistTemplates = payload;
  },
  [ADD_CHECKLIST_TEMPLATE_ITEM]: (state, {
    id,
    checklistData
  }) => {
    state.checklistTemplates.byId = _objectSpread(_objectSpread({}, state.checklistTemplates.byId), {}, {
      [id]: _objectSpread(_objectSpread({}, checklistData), {}, {
        id
      })
    });
    state.checklistTemplates.allIds.push(id.toString());
  },
  [REMOVE_CHECKLIST_TEMPLATE_ITEM]: (state, {
    id
  }) => {
    var _context17;
    Vue.delete(state.checklistTemplates.byId, id);
    state.checklistTemplates.allIds = _filterInstanceProperty(_context17 = state.checklistTemplates.allIds).call(_context17, item => item !== id);
  },
  [ADD_CO_APPLICANT_ITEM]: (state, {
    id
  }) => {
    const newCoappId = uuidv4();
    state.clientProfiles.byId[id].coApplicants = [...state.clientProfiles.byId[id].coApplicants, {
      givenName: "",
      familyName: "",
      phone: "",
      email: "",
      id: newCoappId
    }];
  },
  [REMOVE_CO_APPLICANT_ITEM]: (state, {
    id,
    index
  }) => {
    var _context18;
    _spliceInstanceProperty(_context18 = state.clientProfiles.byId[id].coApplicants).call(_context18, index, 1);
  },
  [UPDATE_CO_APPLICANT_ITEM]: (state, {
    id,
    index,
    payload
  }) => {
    const payloadWithId = _objectSpread(_objectSpread({}, payload), {}, {
      id: uuidv4()
    });
    const payloadToUse = isEmpty(payload) || payload != null && payload.id ? payload : payloadWithId;
    Vue.set(state.clientProfiles.byId[id].coApplicants, index, payloadToUse);
  },
  [UPDATE_STATUS_LABEL]: (state, {
    id,
    statusLabelId
  }) => {
    var _state$clientProfiles8;
    Vue.set(state.clientProfiles.byId[id], "statusLabelId", statusLabelId);
    const selectedLabel = ((_state$clientProfiles8 = state.clientProfiles.byId[id].statusLabels) == null ? void 0 : _findInstanceProperty(_state$clientProfiles8).call(_state$clientProfiles8, x => x.id == statusLabelId)) || {};
    Vue.set(state.clientProfiles.byId[id], "status", selectedLabel);
  },
  [UPDATE_UPDATED_AT]: (state, {
    id,
    updatedAt
  }) => {
    Vue.set(state.clientProfiles.byId[id], "updatedAt", updatedAt);
  },
  [SET_PROFILE_COLLABORATORS]: (state, _ref4) => {
    let {
        id
      } = _ref4,
      details = _objectWithoutProperties(_ref4, _excluded4);
    state.clientProfiles.byId[id].collaborators = _objectSpread(_objectSpread({}, state.clientProfiles.byId[id].collaborators), details);
  },
  [UPDATE_PROFILE_OWNER]: (state, {
    id,
    owner
  }) => {
    Vue.set(state.clientProfiles.byId[id], "owner", owner);
  },
  [SET_CLIENT_PROFILE]: (state, {
    id,
    value,
    statusLabels
  }) => {
    var _context19;
    state.clientProfiles.byId[id] = _objectSpread(_objectSpread({}, state.clientProfiles.byId[id]), value);
    state.clientProfiles.byId[id].statusLabels = statusLabels;
    if (!_includesInstanceProperty(_context19 = state.clientProfiles.allIds).call(_context19, id)) {
      state.clientProfiles.allIds.push(id);
    }
  },
  [TOGGLE_STARRED_APPLICATION]: (state, {
    clientProfileId,
    applicationId = null
  }) => {
    const starredApp = state.clientProfiles.byId[clientProfileId].starredApplicationId;
    Vue.set(state.clientProfiles.byId[clientProfileId], "starredApplicationId", starredApp ? null : applicationId);
  },
  [SET_BOARD_CHANGELOG]: (state, {
    changelog
  }) => {
    state.boardChangelog = [...state.boardChangelog, ...changelog];
  },
  [RESET_BOARD_CHANGELOG]: state => {
    state.boardChangelog = [];
  },
  setDetails: (state, {
    param: id,
    value,
    path
  }) => {
    const field = {
      path,
      value: sanitizeInputs({
        [path]: value
      }, {
        upperFirst: true,
        startCase: false
      })[path]
    };
    const profile = state.clientProfiles.byId[id];
    if (!profile) return;
    updateField(profile, field);
  },
  [SET_CLIENT_LISTS]: (state, {
    clientProfileId,
    lists
  }) => {
    Vue.set(state.lists, clientProfileId, lists);
  },
  [SET_CLIENT_CAMPAIGNS]: (state, {
    clientProfileId,
    campaigns
  }) => {
    Vue.set(state.campaigns, clientProfileId, campaigns);
  },
  [SET_PROFILE_MASTER_SUBSCRIBE]: (state, {
    clientProfileId,
    unsubscribe
  }) => {
    Vue.set(state.clientProfiles.byId[clientProfileId], "masterUnsubscribed", unsubscribe);
    Vue.set(state.clientProfiles.byId[clientProfileId], "authorUnsubscribed", unsubscribe ? "agent" : null);
  },
  [SET_PROFILE_MASTER_SUBSCRIBE_AUTHOR]: (state, {
    clientProfileId,
    author
  }) => {
    Vue.set(state.clientProfiles.byId[clientProfileId], "authorUnsubscribed", author);
  },
  [SET_CLIENT_PROFILES_WITH_CHANGES]: (state, {
    clientProfileIdsWithChanges
  }) => {
    state.clientProfileIdsWithChanges = _reduceInstanceProperty(clientProfileIdsWithChanges).call(clientProfileIdsWithChanges, (acc, curr) => {
      acc[curr] = {
        hasChangelog: true
      };
      return acc;
    }, {});
  },
  [SET_CHANGELOG_LAST_CHANGES]: (state, {
    changelog,
    clientProfileId
  }) => {
    if (!state.clientProfileIdsWithChanges[clientProfileId]) return;
    Vue.set(state.clientProfileIdsWithChanges[clientProfileId], "changelog", [...(state.clientProfileIdsWithChanges[clientProfileId].changelog || []), ...changelog]);
  },
  [REMOVE_CHANGELOG_LAST_CHANGES]: (state, {
    clientProfileId
  }) => {
    if (state.clientProfileIdsWithChanges[clientProfileId]) {
      state.clientProfileIdsWithChanges[clientProfileId] = {
        hasChangelog: true,
        changelog: []
      };
    }
  },
  [SET_EMAIL_BODY]: (state, {
    clientProfileId,
    emailId,
    body
  }) => {
    Vue.set(state.clientProfiles.byId[clientProfileId].timeline.byId[emailId], "body", body);
  },
  [REMOVE_PROFILE_FROM_ORDER]: (state, {
    clientProfileId,
    boardId
  }) => {
    if (state.selectedBoardId) {
      var _boardsStatuses$order;
      const {
        statusLabelId
      } = state.clientProfiles.byId[clientProfileId];
      const boardsStatuses = state.boardsStatuses[boardId].byId[statusLabelId];
      boardsStatuses.order = ((_boardsStatuses$order = boardsStatuses.order) == null ? void 0 : _filterInstanceProperty(_boardsStatuses$order).call(_boardsStatuses$order, o => o !== clientProfileId)) || [];
    }
  },
  [SET_PROFILE_PARTICIPANTS]: (state, {
    clientProfileId,
    participants
  }) => {
    Vue.set(state.clientProfiles.byId[clientProfileId], "participants", participants);
  }
};
export default mutations;